import { useNavigate } from 'react-router-dom';
import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { useActiveProjects } from './hooks/useActiveProjects';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { ROUTES } from '@/routes/paths';

export const activeProjectsConfig: WidgetConfig = {
  id: 'dash-active-projects',
  title: 'Active Projects',
  category: 'list',
  refreshStrategy: 'manual',
  defaultSize: { w: 4, h: 4 },
  priority: 4,
};

export function ActiveProjectsWidget() {
  const navigate = useNavigate();
  const { data, isLoading, isError, error, refetch } = useActiveProjects();

  const activeProjects = data?.projects?.slice(0, 5) || [];

  return (
    <WidgetContainer
      config={activeProjectsConfig}
      isLoading={isLoading}
      isError={isError}
      errorMessage={error?.message}
      onRefresh={() => { refetch(); }}
    >
      <div className="flex flex-col gap-2">
        {activeProjects.length > 0 ? (
          activeProjects.map((project) => (
            <div
              key={project.id}
              className="cursor-pointer rounded-card-sm border border-outline bg-surface p-3 transition-colors hover:border-primary/40 hover:bg-surface-variant"
              onClick={() => navigate(ROUTES.projects)}
            >
              <p className="text-data-md font-semibold text-on-surface">
                {project.name}
              </p>
              <p className="mt-0.5 text-body-sm capitalize text-on-surface-variant">
                {project.status || 'active'}
              </p>
            </div>
          ))
        ) : (
          <p className="text-body-sm text-on-surface-variant italic p-4 text-center">
            No active projects.
          </p>
        )}
      </div>
    </WidgetContainer>
  );
}
